import { render, staticRenderFns } from "./MemberScoreRecords.vue?vue&type=template&id=e14662a6&scoped=true"
import script from "./MemberScoreRecords.vue?vue&type=script&lang=js"
export * from "./MemberScoreRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14662a6",
  null
  
)

component.options.__file = "MemberScoreRecords.vue"
export default component.exports